import { render } from "./DownloadPage.vue?vue&type=template&id=0a99ee0a&scoped=true"
import script from "./DownloadPage.vue?vue&type=script&lang=ts"
export * from "./DownloadPage.vue?vue&type=script&lang=ts"

import "./DownloadPage.vue?vue&type=style&index=0&id=0a99ee0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a99ee0a"

export default script